<template>
    <div>
        <!-- Modal view intervention -->
        <modal :name="'modal-view-intervention' + _uid" height="auto" :scrollable="true" :adaptive="true" width="850px">
            <div class="p-8 overflow-y-auto max-h-[100vh]">
                <div class="flex items-center justify-between mb-4 pb-4 border-b">
                    <h2 class="text-xl font-bold flex items-center gap-2">
                        <i class="fas fa-folder-open text-red-600"></i>
                        Intervention
                    </h2>
                    <button @click="$modal.hide('modal-view-intervention' + _uid)">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>
                <div v-if="selectedInterventionId">
                    <intervention-view :intervention-id="selectedInterventionId" />
                </div>
            </div>
        </modal>

        <!-- Planning mode switcher bar -->
        <div class="planning-switcher">
            <div class="ps-left">
                <span class="ps-label">Affichage</span>
                <div class="ps-toggle">
                    <button :class="['ps-btn', { active: planningMode === 'day' }, 'mr-1']" @click="planningMode = 'day'">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                        Plannification
                    </button>
                    <button :class="['ps-btn', { active: planningMode === 'calendar' }]" @click="planningMode = 'calendar'">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/></svg>
                        Calendrier
                    </button>
                </div>
            </div>

            <!-- Tech selector + week/month toggle — calendar mode only -->
            <!-- <transition name="ps-slide">
                <div v-if="planningMode === 'calendar'" class="ps-tech-selector">
                    <span class="ps-label">Technicien</span>
                    <div class="ps-select-wrap">
                        <div class="ps-tech-dot" :style="{ background: selectedTech ? selectedTech.color : '#94a3b8' }"></div>
                        <select class="ps-select" v-model="selectedTechId">
                            <option v-for="tech in technicians" :key="tech.id" :value="tech.id">
                                {{ tech.name }}
                            </option>
                        </select>
                        <svg class="ps-select-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>
                    </div>
                    <div class="ps-cal-type">
                        <button :class="['ps-cal-btn', { active: calendarType === 'week' }]" @click="calendarType = 'week'">Semaine</button>
                        <button :class="['ps-cal-btn', { active: calendarType === 'month' }]" @click="calendarType = 'month'">Mois</button>
                    </div>
                </div>
            </transition> -->
        </div>

        <!-- ── DAY PLANNER ── -->
        <div v-if="planningMode === 'day'">
            <!-- <div v-if="technicians.length <= 3">
                <technician-planner-vertical
                    :technicians="technicians"
                    :events="events"
                    :unscheduled-events="unscheduledEvents"
                    @event-click="onEventClick"
                    @event-scheduled="onEventScheduled"
                    @date-change="onDateChange"
                    :loading-timeline="loadingTimeline"
                    :loading-unscheduled="loadingUnscheduled"
                />
            </div>
            <div v-else> -->
                <technician-planner-horizontal
                    :technicians="technicians"
                    :events="events"
                    :unscheduled-events="unscheduledEvents"
                    @event-click="onEventClick"
                    @event-scheduled="onEventScheduled"
                    @date-change="onDateChange"
                    :loading-timeline="loadingTimeline"
                    :loading-unscheduled="loadingUnscheduled"
                />
            <!-- </div> -->
        </div>

        <!-- ── CALENDAR VIEW ── -->
        <div v-else>
            <planning-day-month
                v-if="selectedTech"
                :type="calendarType"
                :tech-name="selectedTech.name"
                :tech-color="selectedTech.color"
                :events="calendarEvents"
                :loading="loadingCalendar"
                :technicians="techniciansPlanningDayMonth"
                :accent-color-prop="selectedTech.color"
                :select-first-tech="true"
                @tech-select="onCalendarTechSelect"
                @event-click="onCalendarEventClick"
                @date-change="onCalendarDateChange"
                @period-change="onCalendarPeriodChange"
                @update:type="calendarType = $event"
            />
        </div>
    </div>
</template>

<script>
import InterventionView from '../../Intervention/Components/InterventionView.vue'
import TechnicianPlannerVertical from './TechnicianPlannerVertical.vue'
import TechnicianPlannerHorizontal from './TechnicianPlannerHorizontal.vue'
import PlanningDayMonth from './PlanningDayMonth.vue'

export default {
    components: {
        TechnicianPlannerVertical,
        TechnicianPlannerHorizontal,
        PlanningDayMonth,
        InterventionView,
    },

    props: {
        interventionToPlan: { type: Number, default: null },
        chantierId:         { type: Number, default: null },
    },

    watch: {
        interventionToPlan() {
            this.getUnscheduledEvents()
        },
        chantierId() {
            this.getUnscheduledEvents()
            this.getScheduledEvents()
        },
        // Reload calendar when switching technician
        selectedTechId(newId) {
            if (newId && this.calendarPeriod) {
                this.getCalendarEvents()
            }
        },
    },

    data() {
        return {
            // ── Planning mode ──────────────────────────────────────────────
            planningMode: 'day',    // 'day' | 'calendar'
            calendarType: 'week',   // 'week' | 'month'

            // ── Shared ─────────────────────────────────────────────────────
            selectedDate: new Date().toISOString().substr(0, 10), // YYYY-MM-DD

            // ── Technicians ────────────────────────────────────────────────
            technicians: [],
            selectedTechId: null,

            // ── Day planner ────────────────────────────────────────────────
            events: [],
            unscheduledEvents: [],
            loadingTimeline: false,
            loadingUnscheduled: false,

            // ── Calendar ───────────────────────────────────────────────────
            calendarEvents: [],
            loadingCalendar: false,
            calendarPeriod: null,   // { type, start, end } — set by @period-change

            // ── Modal ──────────────────────────────────────────────────────
            selectedInterventionId: null,
        }
    },

    computed: {
        selectedTech() {
            if (!this.selectedTechId) return this.technicians[0] || null
            return this.technicians.find(t => t.id === this.selectedTechId) || null
        },
        techniciansPlanningDayMonth() {
            // [{ id, name, role?, color }]
            return this.technicians.map(t => ({
                id: t.id,
                name: t.name,
                color: t.color,
            }))
        },
    },

    methods: {

        // ══════════════════════════════════════════════════════════════════
        //  DAY PLANNER — emits
        // ══════════════════════════════════════════════════════════════════

        /**
         * @emit event-click
         * Fired when the user clicks an event block.
         * @param {Object} event — see event format below
         */
        onEventClick(event) {
            if (event.interventionId) {
                this.selectedInterventionId = event.interventionId
                this.$modal.show('modal-view-intervention' + this._uid)
            }
        },

        /**
         * @emit event-scheduled
         * Fired after the user drops + confirms an unscheduled event on the timeline.
         * @param {Object} payload
         *   payload.event          — the original unscheduled event object
         *   payload.technicianId   — id of the target technician
         *   payload.startTime      — 'HH:MM'
         *   payload.endTime        — 'HH:MM'
         */
        async onEventScheduled(payload) {
            const body = {
                date:            this.selectedDate,
                technicien_id:   payload.technicianId,
                intervention_id: payload.event.id,
                heure_debut:     payload.startTime,
                heure_fin:       payload.endTime,
            }
            this.loadingTimeline = true
            this.loadingUnscheduled = true
            try {
                const response = await this.$request.post('/interventions/plan-planner', body)
                if (response == 1) {
                    await this.getUnscheduledEvents()
                    await this.getScheduledEvents()
                    this.$emit('event-scheduled')
                } else {
                    alert("Erreur lors de la planification de l'intervention.")
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.loadingTimeline = false
                this.loadingUnscheduled = false
            }
        },

        /**
         * @emit date-change
         * Fired when the user navigates to a different day in the planner.
         * @param {String} dateStr — 'YYYY-MM-DD'
         */
        onDateChange(dateStr) {
            this.selectedDate = dateStr
            this.getScheduledEvents()
        },

        // ══════════════════════════════════════════════════════════════════
        //  CALENDAR — emits
        // ══════════════════════════════════════════════════════════════════

        /**
         * @emit event-click (calendar)
         * Fired when the user clicks an event pill/block in the calendar.
         * @param {Object} event — see event format below
         */
        onCalendarEventClick(event) {
            if (event.interventionId) {
                this.selectedInterventionId = event.interventionId
                this.$modal.show('modal-view-intervention' + this._uid)
            }
        },

        /**
         * @emit date-change (calendar)
         * Fired when the user selects a day cell (month view) or column (week view).
         * @param {String} dateStr — 'YYYY-MM-DD'
         */
        onCalendarDateChange(dateStr) {
            this.selectedDate = dateStr
            // e.g. open a create-intervention modal pre-filled with this date
        },

        /**
         * @emit period-change
         * Fired on every navigation (arrows, today button, date picker, week↔month switch).
         * This is the MAIN trigger for fetching calendar data.
         * @param {Object} period
         *   period.type   — 'week' | 'month'
         *   period.start  — 'YYYY-MM-DD' (first day of the visible range)
         *   period.end    — 'YYYY-MM-DD' (last day of the visible range)
         */
        onCalendarPeriodChange(period) {
            this.calendarPeriod = period
            this.getCalendarEvents()
        },

        onCalendarTechSelect(tech) {
            this.selectedTechId = tech.id
            this.getCalendarEvents()
        },

        // ══════════════════════════════════════════════════════════════════
        //  API CALLS
        // ══════════════════════════════════════════════════════════════════

        async getTechniciens() {
            try {
                const response = await this.$request.get('/techniciens')
                this.technicians = response.map(t => ({
                    id:    t.id,
                    name:  t.prenom + ' ' + t.nom,
                    role:  'Technicien',
                    color: t.color || '#3b82f6',
                }))
                if (this.technicians.length) {
                    this.selectedTechId = this.technicians[0].id
                }
            } catch (e) {
                console.error('Erreur récupération techniciens :', e)
            }
        },

        async getUnscheduledEvents() {
            this.loadingUnscheduled = true
            try {
                const payload = {}
                if (this.interventionToPlan) payload.intervention_id = this.interventionToPlan
                if (this.chantierId)         payload.chantier_id     = this.chantierId

                const response = await this.$request.post('/interventions/to-schedule', payload)
                this.unscheduledEvents = response.map(e => ({
                    id:       e.id,
                    title:    e.intervention_type?.nom || e.type,
                    duration: e.duree_estimee,
                    client:   (e.client?.prenom + ' ' + e.client?.nom) || '-',
                    address:  `${e.adresse.adresse1} ${e.adresse.code_postal} ${e.adresse.ville}`,
                    priority: 'normal',
                    tags:     [e.appareil?.app_type ? e.appareil.app_type.label : e.appareil.type],
                }))
            } catch (e) {
                console.error('Erreur récupération événements à planifier :', e)
            } finally {
                this.loadingUnscheduled = false
            }
        },

        async getScheduledEvents() {
            this.loadingTimeline = true
            try {
                const payload = { date: this.selectedDate }
                if (this.chantierId) payload.chantier_id = this.chantierId

                const response = await this.$request.post('/interventions/on-day', payload)
                this.events = response.map(e => ({
                    id:             e.id,
                    technicianId:   e.technicien_id,
                    date:           e.date,
                    startTime:      e.heure_debut,
                    endTime:        e.heure_fin,
                    title:          e.intervention && e.intervention.intervention_type ? e.intervention.intervention_type.nom : e.type,
                    client:         e.intervention ? `${e.intervention.client?.prenom} ${e.intervention.client?.nom}` : '-',
                    address:        e.intervention ? `${e.intervention.adresse?.adresse1} ${e.intervention.adresse?.code_postal} ${e.intervention.adresse?.ville}` : '-',
                    interventionId: e.intervention?.id ?? null,
                    status:         e.statut || 'planned',
                    priority:       'normal',
                    tags:           [e.intervention ? e.intervention.appareil.type : '-'],
                }))
            } catch (e) {
                console.error('Erreur récupération événements planifiés :', e)
            } finally {
                this.loadingTimeline = false
            }
        },

        /**
         * POST /interventions/on-period
         * Payload : { technicien_id, date_debut, date_fin }
         * Response: planning rows for the given technician and date range.
         *
         * Each row from the API should map to the event format described below.
         */
        async getCalendarEvents() {
            if (!this.selectedTechId || !this.calendarPeriod) return
            this.loadingCalendar = true
            try {
                const payload = {
                    technicien_id: this.selectedTechId,
                    date_debut:    this.calendarPeriod.start,
                    date_fin:      this.calendarPeriod.end,
                    chantier_id:   this.chantierId || 0,
                }
                const response = await this.$request.post('/interventions/on-period', payload)
                
                this.calendarEvents = response.map(e => ({
                    id:             e.id,
                    date:           e.date,
                    title:          e.intervention ? e.intervention.intervention_type?.nom : e.type,
                    startTime:      e.heure_debut,
                    endTime:        e.heure_fin,
                    duration:       e.duree,
                    client:         e.intervention ? `${e.intervention.client?.prenom} ${e.intervention.client?.nom}` : null,
                    address:        e.intervention ? `${e.intervention.adresse?.adresse1} ${e.intervention.adresse?.code_postal} ${e.intervention.adresse?.ville}` : null,
                    tags:           e.intervention ? [e.intervention.appareil?.type] : [],
                    status:         e.intervention?.statut?.libelle || 'planned',
                    color:          null,
                    interventionId: e.intervention?.id ?? null,
                }))
            } catch (e) {
                console.error('Erreur récupération événements calendrier :', e)
            } finally {
                this.loadingCalendar = false
            }
        },
    },

    async mounted() {
        await this.getTechniciens()
        this.getScheduledEvents()
        this.getUnscheduledEvents()

        this.$eventHub.$on('refresh-intervention-table', () => {
            this.getUnscheduledEvents()
        })
    },
}
</script>

<style scoped>
.planning-switcher {
    display: flex; align-items: center; gap: 16px;
    padding: 10px 16px; background: #fff;
    border-bottom: 1px solid #e4e7ef; flex-wrap: wrap;
    box-shadow: 0 1px 6px rgba(0,0,0,0.05);
    font-family: 'Figtree', sans-serif;
}
.ps-left { display: flex; align-items: center; gap: 10px; }
.ps-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; color: #94a3b8; white-space: nowrap; }
.ps-toggle { display: flex; align-items: center; background: #f4f5f8; border: 1px solid #e4e7ef; border-radius: 10px; padding: 3px; gap: 2px; }
.ps-btn { display: flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 7px; border: none; background: transparent; font-size: 12.5px; font-weight: 600; color: #94a3b8; cursor: pointer; transition: all 0.15s; white-space: nowrap; font-family: inherit; }
.ps-btn:hover { color: #374151; background: #fff; }
.ps-btn.active { background: #fff; color: #1a1d27; box-shadow: 0 1px 6px rgba(0,0,0,0.1); }
.ps-tech-selector { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.ps-select-wrap { display: flex; align-items: center; position: relative; background: #f4f5f8; border: 1px solid #e4e7ef; border-radius: 10px; padding: 0 10px; height: 36px; min-width: 160px; transition: border-color 0.15s; }
.ps-select-wrap:focus-within { border-color: #3b82f6; background: #fff; }
.ps-tech-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-right: 8px; transition: background 0.2s; }
.ps-select { flex: 1; border: none; background: transparent; font-size: 13px; font-weight: 600; color: #1a1d27; cursor: pointer; outline: none; appearance: none; padding-right: 20px; font-family: inherit; }
.ps-select-arrow { position: absolute; right: 10px; pointer-events: none; color: #94a3b8; }
.ps-cal-type { display: flex; align-items: center; background: #f4f5f8; border: 1px solid #e4e7ef; border-radius: 8px; padding: 2px; gap: 2px; }
.ps-cal-btn { padding: 5px 11px; border-radius: 6px; border: none; background: transparent; font-size: 12px; font-weight: 600; color: #94a3b8; cursor: pointer; transition: all 0.15s; white-space: nowrap; font-family: inherit; }
.ps-cal-btn:hover { color: #374151; }
.ps-cal-btn.active { background: #fff; color: #1a1d27; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
.ps-slide-enter-active { transition: opacity 0.2s, transform 0.2s; }
.ps-slide-leave-active { transition: opacity 0.15s, transform 0.15s; }
.ps-slide-enter-from, .ps-slide-leave-to { opacity: 0; transform: translateX(-8px); }
</style>